<template>
	<div class="bar" :class="{sticky}">
		<div class="upload">
			<tooltip :sticky="sticky">Upload an image to preview it</tooltip>
			<input type="file" id="file" accept="image/*" @change="upload" />
			<label for="file" class="button">Upload</label>
		</div>
		<div class="modes tabs">
			<a @click="setMode('cover')" :class="{active: mode === 'cover'}">Cover</a>
			<a @click="setMode('fill')" :class="{active: mode === 'fill'}">Fill</a>
			<a @click="setMode('contain')" :class="{active: mode === 'contain'}"
				>Contain</a
			>
			<a @click="setMode('stretch')" :class="{active: mode === 'stretch'}"
				>Stretch</a
			>
		</div>
	</div>
</template>

<script>
import blobToBase64 from "../modules/blobToBase64";
import tooltip from "./tooltip.vue";

export default {
	components: {tooltip},
	computed: {
		mode() {
			return this.$store.state.mode;
		},
		sticky() {
			const watch = this.$store.state.offsetTop;
			const height = this.$el ? this.$el.getBoundingClientRect().top : 100;
			return height < 1 ? true : false;
		}
	},
	methods: {
		upload(el) {
			const file = el.target.files[0];
			this.$store.state.fileName = file.name.substring(
				0,
				file.name.lastIndexOf(".")
			);
			blobToBase64(file).then((res) => (this.$store.state.file = res));
			goatevent({
				path: location.host + "-hero-upload",
				title: "hero upload",
				event: true
			});
		},
		setMode(mode) {
			this.$store.setMode(mode);
			goatevent({
				path: location.host + `-hero-mode-${mode}`,
				title: `hero mode ${mode}`,
				event: true
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.bar {
	height: 3.5em;
	position: sticky;
	top: 0px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 0 3px 6px transparentize($topBack, 0.7),
		0 1px 3px transparentize($topBack, 0.7);
	z-index: 1;
	background-color: $topBack;
	background-image: $topPattern;
}
.upload {
	position: relative;
	input {
		display: none;
	}
}

.modes {
	margin-left: 2em;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
